export default __webpack_public_path__ + "static/media/roshika.917b31f0.png";